import React, { useState } from 'react'
import moment from 'moment/moment'
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'
import { colors } from '@resiliatech/birdsong'
import { useAppState } from 'Context/AppContext/AppContext'
import { GoalUpdate } from 'Generated/graphql-types'
import {
  Actions,
  Avatar,
  Card,
  Description,
  Details,
  Timestamp,
  TopHalf,
  UserName,
} from './Comment.styled'
import UserAvatar from '../../../../SharedComponents/UserAvatar'

type CommentCardProps = {
  comment: GoalUpdate
  onDeleteComment: () => void
  onEditComment: () => void
}

const UPDATE_DATE_FORMAT = 'dddd MMM D, YYYY h:mma'
const iconStyles = {
  color: colors.interactive.primaryEnabled,
  cursor: 'pointer ',
  fontSize: 'large',
}

export const Comment = ({
  comment,
  onDeleteComment,
  onEditComment,
}: CommentCardProps) => {
  const { userConfig: { id: userId } = {} } = useAppState()
  const user = comment.lastUpdatedUser
  const timestamp =
    comment.updatedAt && comment.updatedAt !== comment.createdAt
      ? `${moment(comment.createdAt).format(UPDATE_DATE_FORMAT)} (edited)`
      : moment(comment.createdAt).format(UPDATE_DATE_FORMAT)

  return (
    <Card key={comment.id}>
      <TopHalf>
        <Details>
          <UserName>
            {user.firstName} {user.lastName}
          </UserName>
          <Timestamp>{timestamp}</Timestamp>
          <Avatar>
            <UserAvatar
              user={user}
              tooltipText={`${user.firstName} ${user.lastName}`}
            />
          </Avatar>
        </Details>
        {userId === user.id && (
          <Actions className='goal-comment-actions'>
            <EditOutlinedIcon onClick={onEditComment} sx={iconStyles} />
            <DeleteOutlineOutlinedIcon
              onClick={onDeleteComment}
              sx={iconStyles}
            />
          </Actions>
        )}
      </TopHalf>
      <Description>{comment.description}</Description>
    </Card>
  )
}
